export enum PaymentEventTypes {
  GTM = 'Gtm',
}
